"use client";

import { IconArrowRightCircle } from "central-icons/IconArrowRightCircle";
import { m } from "motion/react";
import { useState } from "react";
import Comparison from "@/components/preview/comparison";
import DemoCheckbox from "@/components/preview/demo-checkbox";
import { SPRING_FAST } from "@/lib/motion";
import { cn } from "@/lib/utils";
import { MeasurementBadge, MeasurementBand } from "../measurement";

const TEXT_PADDING = 24;

function IconButton({
  optical,
  showPadding,
}: {
  optical: boolean;
  showPadding: boolean;
}) {
  const iconPadding = optical ? 20 : TEXT_PADDING;

  return (
    <div className="relative flex items-center justify-center">
      <MeasurementBadge
        className="top-1/2 -left-16 -translate-y-1/2"
        show={showPadding}
        variant="sky"
      >
        {TEXT_PADDING}px
      </MeasurementBadge>
      <MeasurementBadge
        className="top-1/2 -right-16 -translate-y-1/2"
        show={showPadding}
        variant="sky"
      >
        {iconPadding}px
      </MeasurementBadge>
      <m.button
        className={cn(
          "relative flex h-12 select-none items-center justify-center gap-1.5 overflow-hidden rounded-full bg-preview-bg font-medium text-lg shadow-custom transition-colors duration-200 ease-out will-change-transform hover-hover:hover:bg-gray-100",
          optical ? "pr-5 pl-6" : "px-6"
        )}
        initial={false}
        transition={SPRING_FAST}
        type="button"
        whileTap={{ scale: 0.95 }}
      >
        <MeasurementBand
          className="inset-y-0 left-0"
          show={showPadding}
          style={{ width: TEXT_PADDING }}
          variant="sky"
        />
        <MeasurementBand
          className="inset-y-0 right-0"
          show={showPadding}
          style={{ width: iconPadding }}
          variant="sky"
        />
        Button
        <IconArrowRightCircle className="size-5.5 text-gray-1100" />
      </m.button>
    </div>
  );
}

export default function UiIconPaddingDemo() {
  const [showPadding, setShowPadding] = useState(false);

  return (
    <Comparison
      bad={<IconButton optical={false} showPadding={showPadding} />}
      footer={
        <DemoCheckbox
          checked={showPadding}
          label="Show padding"
          onCheckedChange={setShowPadding}
        />
      }
      good={<IconButton optical showPadding={showPadding} />}
      panelClassName="h-44"
      stackBelow="sm"
    />
  );
}
